module.exports = __webpack_public_path__ + "static/img/minus-symbol.fdfcb7ef.png";